export enum AlleleType {    
    DonorAllele = 1,
    RecipientAllele = 2
}